import { render, staticRenderFns } from "./finish_details.vue?vue&type=template&id=313af9ea&scoped=true&"
import script from "./finish_details.vue?vue&type=script&lang=js&"
export * from "./finish_details.vue?vue&type=script&lang=js&"
import style0 from "./finish_details.vue?vue&type=style&index=0&id=313af9ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313af9ea",
  null
  
)

export default component.exports